export default {
  methods: {
    getProductShortcut(data) {
      // console.log('getProductShortcutdata', data)
      return {
        kid: data?.show_shortcut_kid === true,
        saving: {
          kid: data?.show_shortcut_kid_decoder_saving === true,
        },
        filfulmentRatio: {
          saving: data?.saving_plan?.data?.attributes?.product?.data?.attributes?.insurance_company?.data?.attributes?.saving_input_insurer_ifs?.data[0]?.attributes?.five_star_fulfillment_ratio_insurer === true,
          // aunnity: data?.annuity_plan.data.attributes.product.data.attributes.insurance_company.data.attributes.saving_input_insurer_ifs.data[0].attributes.five_star_fulfillment_ratio_insurer === true
        },
        protection: {
          kid: data?.show_shortcut_kid_decoder_protection === true,
        }
      }
    },
    getSavingFulfilmentShortcut(data) {
      // console.log('getSavingFulfilmentShortcut', data)
      return {
        fulfilmentRatio: {
          saving: data?.saving_plan?.data?.attributes?.product?.data?.attributes?.insurance_company?.data?.attributes?.saving_input_insurer_ifs?.data[0]?.attributes?.five_star_fulfillment_ratio_insurer === true,
        }
      }
    },
    getAnnuityFulfilmentShortcut(data) {
      // console.log('getAnnuityFulfilmentShortcut', data)
      return {
        fulfilmentRatio: {
          annuity: data?.annuity_plan?.data?.attributes?.product?.data?.attributes?.insurance_company?.data?.attributes?.saving_input_insurer_ifs?.data[0]?.attributes?.five_star_fulfillment_ratio_insurer === true
        }
      }
    }
  }
}
